'use client';
import { Dialog } from '@headlessui/react';
import { AiOutlineClose } from 'react-icons/ai';

import Container from '@/components/@base/container';
import VideoPlayer from '@/components/app/product/components/video-player';

type Props = {
  promoteVideo: any;
  promoteVideoCover: any;
  isOpen: boolean;
  onCloseAction: () => void;
};

export const PromoteVideo = ({
  promoteVideo,
  promoteVideoCover,
  isOpen,
  onCloseAction,
}: Props) => {
  if (!promoteVideo) return null;

  const handleClose = () => {
    onCloseAction();
  };

  return (
    <Dialog
      open={isOpen}
      onClose={handleClose}
      className='fixed inset-0 z-50 flex items-center justify-center'
    >
      {/* Close button */}
      <button
        onClick={handleClose}
        className='absolute top-8! left-7 z-40 flex h-7 w-7 cursor-pointer items-center justify-center rounded-md bg-white text-[#959595] transition-colors duration-300 hover:bg-white/80 hover:text-black/60 md:top-[50px] md:left-[53px] md:h-10 md:w-10'
        aria-label='close'
      >
        <AiOutlineClose size={15} />
      </button>
      <div className='fixed inset-0 bg-black/70' aria-hidden='true' onClick={handleClose} />
      <Dialog.Panel
        className='relative z-10 flex max-h-[80vh] max-w-[80vw] items-center justify-center'
        onClick={(e) => e.stopPropagation()}
      >
        <VideoPlayer src={promoteVideo?.publicLink} poster={promoteVideoCover?.publicLink} />
      </Dialog.Panel>
    </Dialog>
  );
};
